module.exports = __webpack_public_path__ + "img/banner-services-desk-min.f543aa1c.jpg";